module.exports = __webpack_public_path__ + "img/tests.d42d6bd4.png";